import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import queryString from 'query-string';

import { API_CONFIG, WINDOW_WIDTH } from './constants/constant';
import { IQueryParameters } from './interface';

import GameClickSound from 'assets/sounds/button.mp3';
import ModalOpenSound from 'assets/sounds/woosh_out.mp3';
import GameFinishSound from 'assets/sounds/game_finished.mp3';
import ChestBuySound from 'assets/sounds/chest_buy.mp3';

export const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

let scrollPosition = 0;

const body = document.getElementsByTagName('body')[0];
const htmlElement = document.getElementsByTagName('html')[0];

export const addOverflow = (oldScrollValue = 0) => {
	const webAppContentWrapper = document.getElementsByClassName('web-app-main-content')[0] as HTMLDivElement;
	if (WINDOW_WIDTH < 600 && htmlElement) {
		htmlElement.style.overflow = 'hidden';
	}
	if (body) {
		if (isSafari) {
			if (oldScrollValue) {
				window.scrollTo({ top: oldScrollValue });
			}
			scrollPosition = window.pageYOffset;
			document.body.style.top =
				(oldScrollValue || scrollPosition) === 0 && window.innerWidth >= 600
					? `40px`
					: `-${oldScrollValue || scrollPosition}px`;
			body.classList.add('lock-position');
			if (webAppContentWrapper) {
				const topPosition = oldScrollValue || scrollPosition;
				webAppContentWrapper.style.top = topPosition > 0 ? `-${topPosition - 88}px` : '88px';
				webAppContentWrapper.classList.add('lock-position');
			}
		}
	}
};

export const removeOverflow = () => {
	const webAppContentWrapper = document.getElementsByClassName('web-app-main-content')[0] as HTMLDivElement;
	if (body) {
		if (WINDOW_WIDTH < 600 && htmlElement) {
			htmlElement.style.overflow = 'auto';
		}
		if (isSafari) {
			body.classList.remove('lock-position');
			document.body.style.removeProperty('top');
			if (webAppContentWrapper) {
				webAppContentWrapper.style.removeProperty('top');
				webAppContentWrapper.classList.remove('lock-position');
				webAppContentWrapper.scrollTo({ top: scrollPosition });
			}
			window.scrollTo({ top: scrollPosition });
		} else {
			body.classList.remove('overflow--hidden');
			webAppContentWrapper && webAppContentWrapper.classList.remove('overflow--hidden');
		}
	}
};

export const registerNewTimeStamp = (date: Date) => {
	return Math.floor(date.getTime() / 1000);
};

const generateRandomString = (length: number) => {
	const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'; // Allowed characters
	let randomString = '';
	for (let i = 0; i < length; i++) {
		randomString += characters.charAt(Math.floor(Math.random() * characters.length));
	}
	return randomString;
};

export const generatePlayerName = () => {
	const randomName = generateRandomString(7);

	const randomNumber = Math.floor(10000000 + Math.random() * 90000000);
	return `${randomName}${randomNumber}`;
};

export const generateRandomNumber = () => {
	const randomNumber = Math.floor(Math.random() * 15) + 1;

	return randomNumber;
};

export const getUrl = (url: string, params: IQueryParameters = {}): string => {
	if (!url.includes('https')) {
		let urlString = `${API_CONFIG.baseUrl}/${url}`;
		if (params && !isEmpty(params)) {
			urlString += `?${queryString.stringify(params)}`;
		}
		return urlString;
	}

	return url;
};

export const formatTime = (seconds: number): string => {
	const hours = Math.floor(seconds / 3600);
	const minutes = Math.floor((seconds % 3600) / 60);
	const secs = seconds % 60;

	// Pad minutes and seconds with leading zeros if needed
	const formattedHours = hours.toString();
	const formattedMinutes = minutes.toString().padStart(2, '0');
	const formattedSeconds = secs.toString().padStart(2, '0');

	return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

export const extractNumberFromString = (str: string): number | null => {
	// Use a regular expression to match the digits at the end of the string
	const match = str.match(/\d+$/);
	return match ? parseInt(match[0], 10) : null; // Convert the match to a number
};

export const extractTextFromString = (str: string) => {
	// Use a regular expression to capture the text part (everything before the number at the end)
	const match = str.match(/^(.+?)\s\d+$/);
	return match ? match[1] : str; // Return the text part if matched, otherwise return the original string
};

export const handleSmoothScroll = (event: any, targetId: string) => {
	event.preventDefault(); // Prevent the default anchor behavior
	const targetElement = document.querySelector(targetId);

	if (targetElement) {
		targetElement.scrollIntoView({
			behavior: 'smooth', // Enable smooth scrolling
			block: 'start' // Scroll to the top of the element
		});
	}
};

export const formatDateRange = (dateRange: Date) => {
	return moment(dateRange).startOf('day').format('YYYY-MM-DDTHH:mm:ssZ');
};

export const convertTimestamp = (timestamp: number) => {
	const currentTime = moment(); // Current time
	const newTime = currentTime.clone().add(timestamp, 'seconds');
	const formattedTime = moment(newTime).format('HH:mm:ss');
	return formattedTime;
};

export const convertToSeconds = (duration: any) => {
	const [hours, minutes, seconds] = duration.split(':').map(Number);
	return hours * 3600 + minutes * 60 + seconds;
};

const currentDate = new Date();
export const formattedDate = currentDate.toLocaleDateString('de-DE', {
	day: '2-digit',
	month: '2-digit',
	year: 'numeric'
});

export enum ISoundKey {
	gameSound = 'gameSound',
	modalOpenSound = 'modalOpenSound',
	gameFinishSound = 'gameFinishSound',
	chestBuySound = 'chestBuySound'
}

export const sounds = {
	[ISoundKey.gameSound]: new Audio(GameClickSound),
	[ISoundKey.modalOpenSound]: new Audio(ModalOpenSound),
	[ISoundKey.gameFinishSound]: new Audio(GameFinishSound),
	[ISoundKey.chestBuySound]: new Audio(ChestBuySound)
};

let isSound = false;
export const soundToggle = (active: boolean) => {
	isSound = active;
};
export const playSound = (sound: ISoundKey) => {
	if (isSound) {
		sounds[sound].play();
	}
};
